import {AcademyData} from "@/constants/constants";
import {getSubdomainFromUrl} from "@/lib/helper/urlSubdomain";


export function logoutFromAcademy() {
    localStorage.removeItem(AcademyData)

}

export function lockOnAcademy(academyData) {
    logoutFromAcademy()
    localStorage.setItem(AcademyData, JSON.stringify(academyData))
}


export function myUserAcademyChildren() {
    let myChildren = myAcademy('user_academies');
    if (myChildren?.children?.length > 0) {
        return myChildren?.children
    }
    return []
}

export function myUserAcademy() {
    return myAcademy('user_academies')
}

export function myAcademySlug() {
    let academySlug = myAcademy('slug');
    if (!academySlug) {
        academySlug = localStorage.getItem('ac')
    }

    if (!academySlug) {
        academySlug = getSubdomainFromUrl()
    }
    return academySlug
}


export function myAcademy(key) {
    const academy = localStorage.getItem(AcademyData)

    if (!academy) {
        return null
    }

    const academyData = JSON.parse(academy)

    if (key) {
        if (academyData[key]) {
            return academyData[key]
        }
        return ''
    }
    return academyData
}
